import Segmente from "./Segmente";
import {v3, quat} from "oc-threejs/short3";


export default class Kleiderbuegelhalter extends Segmente {

    constructor(vsData) {
        super(vsData);
        this.parts = [
            {
                obj: APP.findProduct('Kleiderbuegelhalter_260')?.objName,// "805.01.752_260",
                origin: v3(0.5, 1, 0.5),
                place: v3(0.5, 1, 0.5),
                valid: {
                    achsis: "z",
                    tallerThan: 26,
                    smallerThan: 31
                },
                scale: v3(100, -100, 100),
                quaternion: quat(0, 1, 0, 270)
            },
            {
                obj: APP.findProduct('Kleiderbuegelhalter_310')?.objName,// "805.01.761_310",
                origin: v3(0.5, 1, 0.5),
                place: v3(0.5, 1, 0.5),
                valid: {
                    achsis: "z",
                    tallerThan: 31,
                    smallerThan: 36
                },
                scale: v3(100, -100, 100),
                quaternion: quat(0, 1, 0, 270)
            },
            {
                obj: APP.findProduct('Kleiderbuegelhalter_360')?.objName,// "805.01.770_360",
                origin: v3(0.5, 1, 0.5),
                place: v3(0.5, 1, 0.5),
                valid: {
                    achsis: "z",
                    tallerThan: 36,
                    smallerThan: 41
                },
                scale: v3(100, -100, 100),
                quaternion: quat(0, 1, 0, 270)
            },
            {
                obj: APP.findProduct('Kleiderbuegelhalter_410')?.objName,// "805.01.789_410",
                origin: v3(0.5, 1, 0.5),
                place: v3(0.5, 1, 0.5),
                valid: {
                    achsis: "z",
                    tallerThan: 41,
                    smallerThan: Infinity
                },
                scale: v3(100, -100, 100),
                quaternion: quat(0, 1, 0, 270)
            }
        ]
    }

}